module.exports = ".has-feedback .form-control {\n  padding-right: 42.5px;\n  display: inline-block;\n  width: 70%; }\n\nlabel.editLabel {\n  width: 29%; }\n\n.custom-label span {\n  display: unset !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/edit-staff/edit-staff.component.scss
// module id = ./src/app/admin/edit-staff/edit-staff.component.scss
// module chunks = main